
import angular from 'angular';
import clinkManagerModule from '../angular_apps/clink_manager/scripts/app';

import { angular2react } from 'angular2react';

import 'bootstrap';
import 'tooltip.js';
import 'popper.js';
import '../angular_apps/clink_manager/scripts/controllers/clinks-main';
import { useEffect, useState } from 'react';
import { PageName, ProductsCampaignsDto, UserPermissions } from '../utils/types';
import UnauthorizedPage from './UnauthorizedPage';
import jQuery from 'jquery';
import { PagesHelper } from '../common/PagesHelper';
let abortController = new AbortController();
let $injector:any;

const clinkManagerAngularComponent = {
  bindings: {
    currentUser: '<'
  },
  templateUrl: './clink_manager/views/main/main.html',
  controller: 'MainCtrl'
}

// Expose components to Angular
clinkManagerModule
  .run(['$injector', function (_$injector:any) { $injector = _$injector }])
  .component('clinkManager', clinkManagerAngularComponent);

angular.bootstrap(document.createElement('div'), ['clinkManager'], { strictDi: true });
let ClinkManager:any = angular2react('clinkManager', clinkManagerAngularComponent, $injector);

function CampaignLinksPage(props : any) {
  const [currentUser, setCurrentUser] = useState(props.currentUser);
  const [productsCampaignsDto, setProductsCampaignsDto] = useState<ProductsCampaignsDto>(null);

  if (props.currentUser && props.currentUser !== currentUser) {
    ClinkManager = angular2react('clinkManager', clinkManagerAngularComponent, $injector);
    setCurrentUser(props.currentUser);
  }

  useEffect(() => {
    jQuery("body").tooltip({ selector: ".ngdialog [title]", trigger: "hover", delay: { "show": 250, "hide": 100 } });
    jQuery("#clink-manager-container").tooltip({ selector: "[title]", trigger: "hover", delay: { "show": 250, "hide": 100 } });
  }, [] );
  useEffect(() => {
    if (props.currentUser) {
      PagesHelper.loadProductsAndCampaignsHelper(PageName.products, false, setProductsCampaignsDto);
    }

    return () => {
      if (abortController) abortController.abort();
    };
  }, [props.currentUser]);

  if (!currentUser.permissions.includes(UserPermissions.appptapDashboardsAffiliateDashboard) &&
    !currentUser.permissions.includes(UserPermissions.appptapDashboardsCampaignLinks)) 
  {
    return <UnauthorizedPage />
  } else {
    return (
      <div id="clink-manager-container" style={{ paddingTop: "15px", fontSize: "0.875rem" }}>
        <ClinkManager currentUser={props.currentUser} productsCampaignsDto={productsCampaignsDto} />
      </div>
    );
  }
}

export default CampaignLinksPage;